export default import.meta.ROLLUP_FILE_URL_CFzq7r0G;